import { parseDecimal } from './parse-decimal.util';

export const formatPrice = (value: string | number) =>
  parseDecimal(value).toFixed(2).replace('.', ',');
